import { useMemo } from "react";
import { 
  reviewsData, 
  getReviewsByProduct, 
  getAllReviews, 
  getReviewStats,
  type Review 
} from "@/data/reviews";

export type { Review };

interface UseReviewsOptions {
  productHandle?: string;
}

export function useReviews(options: UseReviewsOptions = {}) {
  const reviews = useMemo(() => {
    if (options.productHandle) {
      return getReviewsByProduct(options.productHandle);
    }
    return getAllReviews();
  }, [options.productHandle]);

  const stats = useMemo(() => getReviewStats(reviews), [reviews]);

  return { 
    reviews, 
    loading: false, 
    error: null, 
    stats 
  };
}

// Re-export formatReviewDate for convenience
export { formatReviewDate } from "@/data/reviews";
